import {
  Box,
  Button,
  Checkbox,
  ComboboxItem,
  Grid,
  Group,
  LoadingOverlay,
  Select,
  TextInput,
  Textarea,
} from "@mantine/core";
import { hasLength, useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck, IconWindow } from "@tabler/icons-react";
import { useEffect, useRef, useState } from "react";
import {
  repositoryMdm,
  repositoryPos,
} from "../../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../../../model/MessageResponse";
import { TblDMInventory } from "../../../../model/TblDMInventory";
import { handleKeyDown } from "../../../../_base/helper/FunctionHelper";
import { sky_blue } from "../../../../const/variables";
import { SelectListItemBase } from "../../../../_base/model/_base/SelectListItemBase";
import {
  getPancakeWarehouses,
  updateInventoryPancakeWarehouse,
} from "./pancakeWarehouseApi";
import { getDistinctAttribute3 } from "./attribute3Api";

const EditDataView = ({ id, fetchData }: EditDataViewProps) => {
  const entity: TblDMInventory = {
    id: "0",
    idBranch: null,
    code: "",
    name: "",
    addr: "",
    type: null,
    phone: null,
    fax: null,
    note: null,
    active: false,
    closeBookDate: null,
    isPrintInvoice: null,
    isPrintReceve: null,
    synDate: null,
    oldInventoryCode: null,
    codeoracle: null,
    positionId: null,
    createBy: null,
    createDate: null,
    lastUpdateBy: null,
    lastUpdateDate: null,
    openBookDate: null,
    attribute1: "",
    attribute2: "",

    attribute3: "",

    attribute4: "",

    attribute5: "",

    attribute6: "",

    attribute7: "",
  };
  //const entity = new TblDMInventory();
  // id: "0",
  // idBranch: null,
  // code: "",
  // name: "",
  // addr: "",
  // type: null,
  // phone: null,
  // fax: null,
  // note: null,
  // active: false,
  // closeBookDate: null,
  // isPrintInvoice: null,
  // isPrintReceve: null,
  // synDate: null,
  // oldInventoryCode: null,
  // codeoracle: null,
  // positionId: null,
  // createBy: null,
  // createDate: null,
  // lastUpdateBy: null,
  // lastUpdateDate: null,
  // openBookDate: null,

  const [visible, { toggle, close, open }] = useDisclosure(false);
  const [enable, setEnable] = useState(false);
  const [listData, setListData] = useState<{ value: string; label: string }[]>(
    []
  );
  const [dataSaleChannel, setDataBranchCode] = useState<any[]>([]); //data chi nhánh
  const [pancakeWarehouses, setPancakeWarehouses] = useState<ComboboxItem[]>(
    [],
  );
  const [attribute3Options, setAttribute3Options] = useState<string[]>([]);
  // giữ danh sách chi nhánh trong ref để hàm validate luôn đọc được dữ liệu mới nhất
  const branchListRef = useRef<any[]>([]);
  const form = useForm<TblDMInventory>({
    mode: "controlled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },

    validate: {
      idBranch: (value: any) => {
        if (!value) {
          return "Vui lòng chọn chi nhánh!";
        }
        return;
      },
      name: (value: string | null) => {
        if (!value) {
          return "Vui lòng nhập tên kho!";
        }
        return hasLength(
          { min: 5, max: 100 },
          "Tên phải từ 5-100 kí tự!"
        )(value as string);
      },
      attribute7: (value: string | null | undefined, values: any) => {
        // kho thuộc chi nhánh của công ty DVT bắt buộc phải có mã bên ERP Asia
        const isDvt =
          branchListRef.current.find(
            (b: any) => String(b.value) === String(values?.idBranch)
          )?.companyCode === "DVT";
        if (isDvt && (!value || value.trim().length === 0)) {
          return "Kho thuộc chi nhánh công ty DVT phải nhập mã kho Asia!";
        }
        if (value && value.length > 200) {
          return "Mã kho Asia không được lớn hơn 200 ký tự!";
        }
      },
      code: (value: string | null) => {
        if (!value) {
          return "Vui lòng nhập mã kho!";
        }
        return hasLength(
          { max: 10 },
          "Mã phải nhỏ hơn 10 kí tự!"
        )(value as string);
      },
      // addr: (value: string | null) => {
      //   if (!value) {
      //     return "Vui lòng nhập địa chỉ kho!";
      //   }
      //   return hasLength(
      //     { max: 250 },
      //     "Địa chỉ không quá 250 kí tự!"
      //   )(value as string);
      // },
      // phone: (value: string | null) => {
      //   if (!value) {
      //     return "Vui lòng nhập số điện thoại!";
      //   }
      //   if (!/^\d{8,10}$/.test(value)) {
      //     return "Số điện thoại phải có từ 8 đến 10 chữ số!";
      //   }
      // },
      // note: (value: string | null) => {
      //   if (value && hasLength({ max: 250 })(value)) {
      //     return "Ghi chú không quá 250 kí tự!";
      //   }
      // },
    },
  });
  const [selectedSubInvLabel, setSelectedSubInvLabel] = useState<string | null>(
    null
  );

  //create chỉnh sửa
  const handleEditTblDMInventory = async (dataSubmit: TblDMInventory) => {
    debugger;
    if (dataSubmit.attribute2) {
      dataSubmit.attribute2 = "HB";
    } else {
      dataSubmit.attribute2 = "";
    }
    if (dataSubmit.attribute5) {
      dataSubmit.attribute5 = "1";
    } else {
      dataSubmit.attribute5 = "";
    }
    console.log(dataSubmit);
    open();
    const dataApi = await repositoryPos.post<MessageResponse<TblDMInventory>>(
      "/api/v1/TblDmInventory/edit",
      { ...dataSubmit, idBranch: Number(dataSubmit.idBranch) }
    );
    if (dataApi?.success) {
      // Kho Pancake lưu bằng API riêng, chỉ gọi khi người dùng có đổi kho
      if (form.isDirty("attribute6")) {
        const res = await updateInventoryPancakeWarehouse(
          String(id),
          dataSubmit.attribute6 || null,
        );
        if (!res?.success) {
          NotificationExtension.Fails("Cập nhật kho Pancake thất bại!");
          close();
          return;
        }
      }
      await fetchData();
      modals.closeAll();
      NotificationExtension.Success("Cập nhật thành công!!!");
    }

    close();
  };

  //lấy data để chỉnh sửa
  const callApiGetData = async () => {
    open();
    const callapi = await repositoryPos.get<MessageResponse<TblDMInventory>>(
      `/api/v1/TblDMInventory/edit?id=${id}`
    );

    if (!callapi?.success) {
      NotificationExtension.Fails("Bạn không có quyền sửa!!!");
      modals.closeAll();
      return;
    }

    if (callapi) {
      const dataApi = callapi?.data;
      if (dataApi != null) {
        form.setValues({
          ...dataApi,
          idBranch: String(dataApi.idBranch),
        });
        form.resetDirty(dataApi);
        // const selectedWarehouse = listData.find(
        //   (item) => Number(item.value) === callapi?.data?.type
        // );
        // setSelectedSubInvLabel(
        //   selectedWarehouse ? selectedWarehouse.label : null
        // );
      }
      close();
    } else {
      modals.closeAll();
    }
  };

  //Call api tên loại kho
  const fetchDataNV = async () => {
    try {
      const response = await repositoryMdm.get(
        `api/v1/TblDmInventoryGroup/get-inv-group-name`
      );
      if (response && response.success) {
        const data = response.data;
        const formattedData = data.map((item: any) => ({
          value: String(item.id),
          label: item.invGroupName,
        }));
        setListData(formattedData);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  /**
   * Kho thuộc chi nhánh pháp nhân DVT được phép sửa toàn bộ thông tin.
   */
  const isDvtBranch =
    dataSaleChannel.find(
      (b: any) => String(b.value) === String(form.getValues().idBranch),
    )?.companyCode === "DVT";

  //Call api chi nhánh
  const DataBranchCode = async () => {
    try {
      const response = await repositoryPos.get<MessageResponse<[]>>(
        `api/v1/TblDmInventory/get-select-branch?auth=true`
      );
      if (response && response.success) {
        const result = response.data
          .filter((i: any) => i.value !== null && i.text !== null)
          .map((item: any) => ({
            value: String(item.value),
            label: item.text,
            // attr6 của get-select-branch chính là CompanyCode của chi nhánh
            companyCode: item.attr6,
          }));
        setDataBranchCode(result);
        branchListRef.current = result;
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  useEffect(() => {
    if (id) {
      Promise.all([
        callApiGetData(),
        DataBranchCode(),
        getPancakeWarehouses().then(setPancakeWarehouses),
        getDistinctAttribute3().then(setAttribute3Options),
      ]);
    }
  }, [id]);

  useEffect(() => {
    if (form.isDirty()) {
      setEnable(true);
    } else {
      setEnable(false);
    }
  }, [form]);
  return (
    <>
      <Box
        component="form"
        mx="auto"
        w={{ base: "250px", md: "300px", lg: "400px" }}
        onSubmit={form.onSubmit((e: TblDMInventory) => {
          handleEditTblDMInventory(e);
        })}
        style={{ position: "relative" }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />

        <Grid mt={10}>
          <Grid.Col span={{ base: 12, md: 6 }}>
            <Select
              label="Chi nhánh"
              withAsterisk
              readOnly
              variant="filled"
              data={dataSaleChannel}
              onClick={() => {
                if (dataSaleChannel.length === 0) {
                  DataBranchCode();
                }
              }}
              placeholder="Chọn chi nhánh"
              key={form.key("idBranch")}
              {...form.getInputProps("idBranch")}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6 }}>
            <TextInput
              label={"Mã kho"}
              placeholder={"Nhập mã kho"}
              type="text"
              withAsterisk
              readOnly
              variant="filled"
              onKeyDown={handleKeyDown}
              {...form.getInputProps("code")}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6 }}>
            <TextInput
              label={"Tên kho"}
              placeholder={"Nhập tên kho"}
              type="text"
              readOnly
              variant="filled"
              withAsterisk
              w={"100%"}
              {...form.getInputProps("name")}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6 }}>
            <TextInput
              label={"Mã kho Asia"}
              placeholder={"Nhập mã kho bên ERP Asia"}
              type="text"
              w={"100%"}
              withAsterisk={isDvtBranch}
              key={form.key("attribute7")}
              {...form.getInputProps("attribute7")}
            />
          </Grid.Col>
          <Grid.Col span={12}>
            <Select
              label="Kho Pancake"
              placeholder="Chọn kho Pancake"
              searchable
              clearable
              data={pancakeWarehouses}
              key={form.key("attribute6")}
              {...form.getInputProps("attribute6")}
            />
          </Grid.Col>
          <Grid.Col span={12}>
            <Select
              label="Thuộc tính"
              placeholder="Chọn Attribute3"
              searchable
              clearable
              data={attribute3Options}
              key={form.key("attribute3")}
              {...form.getInputProps("attribute3")}
            />
          </Grid.Col>
          <Grid.Col span={12}>
            <Checkbox
              readOnly={!isDvtBranch}
              label={"Sử dụng"}
              checked={form.values.active}
              {...form.getInputProps("active")}
            />
          </Grid.Col>
          <Grid.Col span={12}>
            <Checkbox
              label={"Bán hàng"}
              checked={form.values.attribute2 ? true : false}
              //  value={form.values.attribute2 ? "HB" : undefined}
              {...form.getInputProps("attribute2")}
            />
          </Grid.Col>
          <Grid.Col span={12}>
            <Checkbox
              label={"Điều chuyển LCN"}
              checked={form.values.attribute5 ? true : false}
              //value={form.values.attribute5 ? "1" : undefined}
              {...form.getInputProps("attribute5")}
            />
          </Grid.Col>
        </Grid>

        {/* <Grid>
          <Grid.Col>
            <TextInput
              label={"Địa chỉ"}
              placeholder={"Nhập địa chỉ kho"}
              type="text"
              withAsterisk
              {...form.getInputProps("addr")}
            />
          </Grid.Col>
        </Grid>

        <Grid>
          <Grid.Col span={6}>
            <TextInput
              label={"Điện thoại"}
              placeholder={"Nhập số điện thoại"}
              type="number"
              withAsterisk
              {...form.getInputProps("phone")}
            />
          </Grid.Col>
          <Grid.Col span={6}>
            <TextInput
              label={"Fax"}
              placeholder={"Nhập fax"}
              type="number"
              {...form.getInputProps("fax")}
            />
          </Grid.Col>
        </Grid>

        <Grid>
          <Grid.Col span={6}>
            <TextInput
              label={"Mã vùng"}
              placeholder={"Nhập mã vùng"}
              type="text"
              {...form.getInputProps("positionId")}
            />
          </Grid.Col>
          <Grid.Col span={6}>
            <TextInput
              label={"Trung tâm khác"}
              placeholder={"Nhập trung tâm"}
              type="text"
              {...form.getInputProps("oldInventoryCode")}
            />
          </Grid.Col>
        </Grid> */}

        {/* <Grid align="center">
          <Grid.Col span={6}>
            <TextInput
              label={"Mã kho ORC"}
              placeholder={"Nhập mã kho"}
              type="text"
              {...form.getInputProps("codeoracle")}
            />
          </Grid.Col>
          <Grid.Col span={6}>
            <Select
              id="type"
              key={form.key("type")}
              label={"Tên loại kho"}
              placeholder={"Nhập loại kho"}
              withAsterisk
              data={listData}
              value={form.getValues().type?.toString()}
              clearable
              onChange={(e) => {
                form.setValues((prev) => ({
                  ...prev,
                  type: e ? Number(e) : null,
                }));

                const selectedWarehouse = listData.find(
                  (item) => item.value === e
                );
                setSelectedSubInvLabel(
                  selectedWarehouse ? selectedWarehouse.label : null
                );
              }}
            />
          </Grid.Col>
        </Grid> */}

        {/* <Grid align="center">
          <Grid.Col span={12}>
            <Textarea
              label={"Ghi chú"}
              placeholder="Nhập ghi chú"
              w={"100%"}
              {...form.getInputProps("note")}
            />
          </Grid.Col>
        </Grid> */}

        <Group
          justify="end"
          mt="xs"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button
            type="button"
            color="gray"
            loading={visible}
            onClick={() => {
              modals.closeAll();
            }}
            leftSection={!visible ? <IconWindow size={18} /> : undefined}
          >
            Đóng
          </Button>
          <Button
            type="submit"
            color={sky_blue.base}
            disabled={!enable}
            loading={visible}
            leftSection={!visible ? <IconCheck size={18} /> : undefined}
          >
            Lưu
          </Button>
          <></>
        </Group>
      </Box>
    </>
  );
};

export default EditDataView;

type EditDataViewProps = {
  id: string | number;
  fetchData: any;
};
